import resource from '../../../../Core/Util/resources';
import {sprintf} from 'sprintf-js';

const language = {
    dutch: {
        processing: resource('DataTable_Processing'),
        search: resource('DataTable_Search'),
        searchPlaceholder: resource('DataTable_Search'),
        lengthMenu: sprintf(resource('DataTable_LengthMenu'), '_MENU_'),
        loadingRecords: resource('DataTable_LoadingRecords'),
        paginate: {
            first: resource('DataTable_Paginate_First'),
            previous: resource('DataTable_Paginate_Previous'),
            next: resource('DataTable_Paginate_Next'),
            last: resource('DataTable_Paginate_Last')
        },
        aria: {
            sortAscending: ": " + resource('DataTable_Aria_SortAscending'),
            sortDescending: ": " + resource('DataTable_Aria_SortDescending')
        },
        infoFiltered: "",
        infoPostFix: "",
        info: sprintf(resource('DataTable_Info'), '_START_', '_END_', '_TOTAL_'),
        infoEmpty: "",
        zeroRecords: resource('DataTable_ZeroRecords'),
        emptyTable: resource('DataTable_EmptyTable')
    }
}

export default {
    language
}

export {
    language
}
